import { z } from 'zod';
import { MAX_FILE_SIZE_BYTES, MEGA_BYTE_TO_BYTE, MIN_FILE_SIZE_BYTES, VALID_FILE_EXTENSIONS } from '../constants';
import { isValidFileExtension, truncateFileName } from '../helper';

// applicationId is the pre-application identifier (= quote/trackingId). It
// is not the 8-char Application.id at this point in the flow, so we don't
// reuse `requiredApplicationIdString()` here.
export const createTitleOwnerDocumentSchema = z.object({
  applicationId: z.string().min(1, 'applicationId is required'),
  titleSearchOwnerId: z.string().min(1, 'titleSearchOwnerId is required'),
  fileSize: z
    .number()
    .min(MIN_FILE_SIZE_BYTES, `File size must be greater than ${MIN_FILE_SIZE_BYTES / 1024} KB`)
    .max(MAX_FILE_SIZE_BYTES, `File size must be less than ${MAX_FILE_SIZE_BYTES / MEGA_BYTE_TO_BYTE} MB`),
  filename: z
    .string()
    .trim()
    .min(5)
    .refine(file => isValidFileExtension(file, VALID_FILE_EXTENSIONS), 'Invalid file extension')
    .transform(file => truncateFileName(file)),
});
